// Platform model administration: providers, per-purpose assignments and scenario runs against a candidate.
// Capability-gated (platform_model_admin); never workspace-scoped except the explicit scenario run, which also
// requires the caller's own membership in that workspace.
import { z } from 'zod';
import * as M from './api-models.js';
import { OkSchema, PublishSchema, RollbackSchema } from './api.js';
import { IdParam, route } from './route-def.js';

const Provider = z.object({ providerId: IdParam });
const cap = 'platform_model_admin' as const;

export const modelRoutes = {
  modelAdminOverview: route({ method: 'GET', path: '/platform/models', summary: 'Proveedores de modelos, asignaciones por uso y estado efectivo', tag: 'platform', capability: cap, response: M.ModelAdminOverviewSchema }),
  createModelProvider: route({
    method: 'POST', path: '/platform/models/providers', summary: 'Agregar un proveedor de modelos (la clave se guarda cifrada y no se vuelve a mostrar)', tag: 'platform',
    capability: cap, body: M.CreateModelProviderSchema, response: M.ModelProviderSchema, status: 201,
  }),
  updateModelProvider: route({
    method: 'PATCH', path: '/platform/models/providers/:providerId', summary: 'Cambiar nombre, URL base o clave (vuelve a «sin probar»)', tag: 'platform',
    capability: cap, params: Provider, body: M.UpdateModelProviderSchema, response: M.ModelProviderSchema,
  }),
  testModelProvider: route({
    method: 'POST', path: '/platform/models/providers/:providerId/test', summary: 'Probar las credenciales con una llamada real al modelo', tag: 'platform',
    capability: cap, params: Provider, body: M.TestModelProviderSchema, response: M.ModelProviderTestResultSchema,
  }),
  archiveModelProvider: route({
    method: 'DELETE', path: '/platform/models/providers/:providerId', summary: 'Archivar un proveedor que no está asignado', tag: 'platform',
    capability: cap, params: Provider, response: OkSchema,
  }),
  saveModelConfigDraft: route({ method: 'PUT', path: '/platform/models/draft', summary: 'Guardar borrador de asignaciones', tag: 'platform', capability: cap, body: M.SaveModelConfigDraftSchema, response: M.ModelConfigReleaseSchema }),
  publishModelConfig: route({ method: 'POST', path: '/platform/models/publish', summary: 'Publicar el borrador de asignaciones', tag: 'platform', capability: cap, body: PublishSchema, response: M.ModelConfigReleaseSchema }),
  rollbackModelConfig: route({ method: 'POST', path: '/platform/models/rollback', summary: 'Restaurar una versión de asignaciones', tag: 'platform', capability: cap, body: RollbackSchema, response: M.ModelConfigReleaseSchema }),
  runModelScenarios: route({
    method: 'POST', path: '/platform/models/scenario-runs', summary: 'Ejecutar los escenarios de un espacio propio contra un modelo (efectivo, borrador o candidato)', tag: 'platform',
    capability: cap, body: M.RunModelScenariosSchema, response: M.ModelScenarioRunSchema,
  }),
};
